import { Component, OnInit, Input, Output } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { IApplication } from '../../../interfaces/graph-types';
import { CandidateService } from '../../../services/candidate.service';

@Component({
  selector: 'application-panel',
  template: require('./application-panel.component.pug'),
  styles: [require('./application-panel.component.css').toString()],
})
export class ApplicationPanelComponent implements OnInit {
  @Input()
  application: IApplication;

  @Input()
  accountId: string;

  applicationStageName: string;
  applicationStage: number;
  processAt: string;

  bsModalRef: BsModalRef;

  applicationStageClasses = {
    30: 'badge-primary',
    40: 'badge-danger',
    50: 'badge-unsub',
    60: 'badge-warning',
    70: 'badge-warning',
    100: 'badge-success',
    130: 'badge-success',
    500: 'badge-secondary',
  }

  applicationSubjectId: Subject<string>;

  // -------------------------------------------------------------------
  constructor(
    private modalService: BsModalService,
    private candidateService: CandidateService,
  ) {
    this.applicationSubjectId = new Subject<string>();
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.applicationStage = this.application.stage;
    this.applicationStageName = this.application.stageName;
    this.processAt = this.application.processAt;
  }

  // -------------------------------------------------------------------
  getAccountId() {
    return this.accountId;
  }

  // -------------------------------------------------------------------
  onSuccess() {}

  // -------------------------------------------------------------------
  onFailure() {}


  // -------------------------------------------------------------------
  setApplication(applicationId) {
    this.applicationSubjectId.next(applicationId)
  }

  // -------------------------------------------------------------------
  closeApplicationInfo() {
  }

}
